export const ENV = Object.freeze({
  NODE_ENV: process.env.NODE_ENV,
  UI_KIT: process.env.UI_KIT,
  WIDGET_NAME: process.env.WIDGET_NAME,
  BUILD_VERSION: process.env.BUILD_VERSION,
  BUILD_TIMESTAMP: process.env.BUILD_TIMESTAMP,
  COMMIT_HASH: process.env.COMMIT_HASH,
  BRANCH_NAME: process.env.BRANCH_NAME,
});
